<!-- 在学课程 -->
<template>
  <div class="online-course">
    <h2 class="title">在学课程</h2>
    <div class="course-main">
      <div class="main-title">
        <span>课程列表</span>
        <span>时间</span>
        <span>课程教程</span>
      </div>
      <div class="main-conent" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ item.create_time | dateFormat }}</span>
        <span @click="openWindow(item.id)" style="cursor: pointer"
          >查看PPT课程</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import encrypt from "../utils/encrypt";
import { getStudentCourseList } from "@/api/common";
import { getToken, getUid } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      total: 0,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openWindow(val) {
      this.$router.push({
        path: "/online-coursed",
        query: {
          id: val,
        },
      });
    },
    fetchData(ids) {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
        page: 1,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getStudentCourseList(params).then((response) => {
        this.dataList = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.title {
  padding-left: 37px;
  padding-right: 60px;
  font-size: 24px;
  color: #00468e;
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #ebebeb;
}
.course-main {
  height: calc(100% - 75px);
  padding-top: 37px;
  padding-left: 37px;
  padding-right: 60px;
  .main-title {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 27px;
    font-size: 15px;
    color: #000000;
    border-bottom: 1px solid #d7d7d7;
    span {
      padding-left: 9px;
    }
  }
  .main-conent {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 48px;
    line-height: 48px;
    font-size: 15px;
    color: #666666;
    border-bottom: 1px solid #d7d7d7;
    span {
      padding-left: 9px;
    }
  }
}
</style>
